import React from 'react';
import { getDisplayOfRowName } from './utils';

export default (rowName, data, otherChildren = []) => (
  <>
    {getDisplayOfRowName(rowName, data)}
    {otherChildren}
  </>
);
